(function() {
    'use strict';

    angular
        .module('valueconnectApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('hubspot-lead', {
            parent: 'entity',
            url: '/hubspot-lead?page&sort&search',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'valueconnectApp.hubspotLead.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/hubspot-lead/hubspot-leads.html',
                    controller: 'HubspotLeadController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'id,asc',
                    squash: true
                },
                search: null
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort),
                        search: $stateParams.search
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('hubspotLead');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('hubspot-lead-detail', {
            parent: 'entity',
            url: '/hubspot-lead/{id}',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'valueconnectApp.hubspotLead.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/hubspot-lead/hubspot-lead-detail.html',
                    controller: 'HubspotLeadDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('hubspotLead');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'HubspotLead', function($stateParams, HubspotLead) {
                    return HubspotLead.get({id : $stateParams.id}).$promise;
                }]
            }
        })
        .state('hubspot-lead.new', {
            parent: 'hubspot-lead',
            url: '/new',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/hubspot-lead/hubspot-lead-dialog.html',
                    controller: 'HubspotLeadDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                vid: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('hubspot-lead', null, { reload: true });
                }, function() {
                    $state.go('hubspot-lead');
                });
            }]
        })
        .state('hubspot-lead.edit', {
            parent: 'hubspot-lead',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/hubspot-lead/hubspot-lead-dialog.html',
                    controller: 'HubspotLeadDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['HubspotLead', function(HubspotLead) {
                            return HubspotLead.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('hubspot-lead', null, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('hubspot-lead.delete', {
            parent: 'hubspot-lead',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/hubspot-lead/hubspot-lead-delete-dialog.html',
                    controller: 'HubspotLeadDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['HubspotLead', function(HubspotLead) {
                            return HubspotLead.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('hubspot-lead', null, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();
